<div #desc class="featured-product-description">
  {{ description }}
</div>
